import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import '../../../css/topicOverlay.css';

const TopicOverlay = ({ topic, onClose, onUpdate }) => {
  const [editData, setEditData] = useState({ name: '', description: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (topic) {
      setEditData({ name: topic.name || '', description: topic.description || '' });
    }
  }, [topic]);

  const handleChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      await api.put(`/topics/${topic.id}`, editData, {
        headers: { 'Content-Type': 'application/json' }
      });
      setSuccess('Topic aggiornato con successo!');
      if (onUpdate) onUpdate();
      setTimeout(() => onClose(), 1500);
    } catch (err) {
      console.error("Errore nell'aggiornamento del topic:", err);
      setError("Errore nell'aggiornamento del topic.");
    }
  };

  return (
    <div className="topic-overlay-container" onClick={onClose}>
      <div className="topic-overlay-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        <h2>Modifica Topic</h2>
        {error && <p className="error">{error}</p>}
        {success && <p className="success">{success}</p>}
        <form onSubmit={handleSubmit}>
          <label>
            Nome:
            <input
              type="text"
              name="name"
              value={editData.name}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Descrizione:
            <textarea
              name="description"
              value={editData.description}
              onChange={handleChange}
            />
          </label>
          <button type="submit">Salva</button>
        </form>
      </div>
    </div>
  );
};

export default TopicOverlay;
